import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Dialog, Spinner} from '../../widgets';
import CommunityCard from '../../community/CommunityCard';

import {uiActions} from '../../chrome';
import couponActions from '../../community/coupons/coupons.actions';
import streamActions from '../../stream/stream.actions';

import './CommunityList.css';

class CommunityList extends Component {
	componentWillUnmount() {}

	render() {
		const {
			onCancel,
			session,
			affiliations,
			affiliationsLoading,
			communityCardClickHandler
		} = this.props;

		let currentProviderUuid =
			session && session.current && session.current.provider && session.current.provider.uuid;

		return (
			<Dialog title="Select Community" submitOnEnter={false} onCancel={onCancel} buttons={[]}>
				<div className="communiyListContainer">
					{affiliationsLoading ? (
						<Spinner />
					) : (
						affiliations &&
						affiliations.map(community => (
							<CommunityCard
								key={community.uuid}
								community={community}
								disabled={!community.subscription}
								enableLink={false}
								onClick={() => communityCardClickHandler(currentProviderUuid, community)}
							/>
						))
					)}
				</div>
			</Dialog>
		);
	}
}

const mapStateToProps = state => {
	return {
		affiliations: state.session.communities,
		affiliationsLoading: state.session.affiliationsLoading,
		session: state.session
	};
};

const mapDispatchToProps = dispatch => {
	return {
		communityCardClickHandler: (userUuid, community) => {
			// if community has subscribed for paid features, then allow adding coupon
			if (community.subscription) {
				dispatch(uiActions.uiModal(null));
				dispatch(couponActions.couponAdding({userUuid: userUuid, communityUuid: community.uuid}));
				setTimeout(() => {
					dispatch(uiActions.uiModal('add-coupon'));
					dispatch(streamActions.streamPromotionAddModelOpened());
				}, 100);
			} else {
				/* dispatch(uiActions.uiModal(null)); */

				// show alert to tell user about not supported feature
				/* setTimeout(() => { */
				dispatch(
					uiActions.uiMessage({
						content: () => (
							<div>
								<strong>Promotion feature not available for this community</strong>
								<div>
									<p>
										The community you have selected does not support this feature yet. Please
										contact community admin to request this feature.
									</p>
								</div>
							</div>
						),
						type: 'error'
					})
				);
				/* }, 100); */
			}
		},
		onCancel: () => {
			dispatch(uiActions.uiModal(null));
			dispatch(streamActions.communityListingModelClosed());
		},
		closeModel: () => {
			dispatch(streamActions.communityListingModelClosed());
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CommunityList);



// WEBPACK FOOTER //
// ./src/mobile/community-list/CommunityList.js